// Placeholder Settings surface. The rail item already exists; this page
// gives the click somewhere to land while we build out the real
// preferences UI (theme, notification opt-outs, account, etc).

import { IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';

import { logoutUser } from '../firebase';

const Settings: React.FC = () => {
  const history = useHistory();

  async function handleLogout() {
    if (!window.confirm('Log out?')) return;
    try {
      await logoutUser();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Logout failed', err);
    }
  }

  return (
    <IonPage>
      <IonContent fullscreen>
        <div className="pm-app">
          <div className="pm-page" style={{ maxWidth: 720, padding: '24px 28px' }}>
            <div className="pm-header">
              <div className="pm-header-titles">
                <h1>Settings</h1>
                <p>Account-level preferences and sign-out. More controls coming soon.</p>
              </div>
            </div>

            {/* Just enough surface to make this page useful today: an
              * explicit sign-out button. Future sections (theme, notification
              * opt-outs, personal integrations) drop in here as new cards.
              *
              * Hand-rolled card chrome — .pm-stat-cards is a 4-column grid
              * for stat tiles, not a single-column form container, so we
              * use the design tokens directly. */}
            <div
              style={{
                marginTop: 16,
                background: 'var(--rr-paper, #fff)',
                border: '1px solid var(--pm-border, var(--rr-stone-300))',
                borderRadius: 'var(--pm-radius-lg, 12px)',
                padding: '16px 18px',
              }}
            >
              <div className="pm-stat-label">Session</div>
              <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                <button
                  type="button"
                  className="pm-button pm-button-danger"
                  onClick={handleLogout}
                >
                  Sign out
                </button>
                <button
                  type="button"
                  className="pm-button pm-button-ghost"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Settings;
